module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notificationBox",
    class: {
      'ok': _vm.type === 'ok', 'warning': _vm.type === 'warning'
    }
  }, [_c('div', {
    staticClass: "content content-icon"
  }, [_c('i', {
    class: {
      'el-icon-success': _vm.type === 'ok', 'el-icon-warning': _vm.type === 'warning'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content-text"
  }, [_c('label', [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab84f7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/ReschedulingPage/SpNotificationBox.vue
// module id = 680
// module chunks = 0